export default __webpack_public_path__ + "static/media/order_catalog.c29d1d09.jpg";